import { LocalizationProvider} from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React from "react";
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";

function DateAndTimePicker({children}) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateAndTimePicker']}>
                {children}
            </DemoContainer>
        </LocalizationProvider>
    );
}

export default DateAndTimePicker;

